import { FC, useState } from 'react';
import { observer } from 'mobx-react';
import { BodyText, Headline, Icon, Stack, Link, Button, Card } from '@servicetitan/design-system';
import { Preferences } from '../../components/preferences/preferences';
import { PageWrapper } from '../../components/page-wrapper/page-wrapper';
import { SubscriptionStore } from '../../stores/subscription.store';
import { useDependencies } from '@servicetitan/react-ioc';
import classnames from 'classnames';
import * as Styles from '../../components/page-wrapper/page-wrapper.module.less';

export const UnsubscribePage: FC = observer(() => {
    const [showPreferences, setShowPreferences] = useState(false);
    const [marketingStore] = useDependencies(SubscriptionStore);

    const handleUnsubscribeRequest = () => {
        marketingStore.updatePreferences();
    };

    const getCensoredEmailAddress = (address: string) => {
        const emailParts = marketingStore.email.split('@');
        const addressee = emailParts[0];

        if (addressee.length <= 2) {
            return address;
        }

        const censoredAddressee =
            addressee[0] + '*'.repeat(addressee.length - 2) + addressee.slice(-1);

        const censoredAddress =
            emailParts.length > 1 ? censoredAddressee + '@' + emailParts[1] : censoredAddressee;

        return censoredAddress;
    };

    return (
        <PageWrapper>
            <Card raised className={classnames(Styles.unsubscribePage, 'qa-page-main-card')}>
                {!showPreferences ? (
                    !marketingStore.submitted ? (
                        <Stack alignment="leading" direction="column" alignItems="center">
                            <Headline size="large" className="m-y-2">
                                Sorry to see you go
                            </Headline>
                            <BodyText className="m-y-2">
                                <b>Email: {getCensoredEmailAddress(marketingStore.email)}</b>
                            </BodyText>
                            <BodyText className="m-y-2">
                                If you'd like to unsubscribe from all marketing emails please
                                confirm by clicking the <b>Unsubscribe</b> button below.
                            </BodyText>
                            <BodyText className="m-y-2">
                                If you'd like to only receive certain types of marketing messages
                                then{' '}
                                <Link
                                    onClick={() => setShowPreferences(true)}
                                    color="primary"
                                    className="qa-update-preferences-link"
                                >
                                    click here
                                </Link>{' '}
                                to update your preferences.
                            </BodyText>
                            <Button
                                className="qa-unsubscribe-button m-t-3"
                                onClick={handleUnsubscribeRequest}
                                disabled={false}
                                primary
                            >
                                Unsubscribe
                            </Button>
                        </Stack>
                    ) : (
                        <Stack direction="column" alignItems="center" className="m-y-2">
                            <Icon name="notifications_off" size="48px" color="#8C9CA5" />
                            <Headline size="large" className="m-y-2">
                                Unsubscribed
                            </Headline>
                            <BodyText>
                                You will no longer receive marketing emails from us.
                            </BodyText>
                            <BodyText>
                                <Link
                                    onClick={() => setShowPreferences(true)}
                                    color="primary"
                                    className="qa-update-preferences-link"
                                >
                                    Click here
                                </Link>{' '}
                                to update your email subscriptions.
                            </BodyText>
                        </Stack>
                    )
                ) : (
                    <Preferences />
                )}
            </Card>
        </PageWrapper>
    );
});
